import React, { useEffect, useRef } from 'react';

interface SmartEditorProps {
  id?: string;
  defaultValue?: string;
  height?: string;
  onChange?: (content: string) => void;
}

declare global {
  interface Window {
    nhn: any;
  }
}

const SmartEditor: React.FC<SmartEditorProps> = ({
  id = 'smarteditor',
  defaultValue = '',
  height = '400px',
  onChange,
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const editorRef = useRef<any>(null);

  useEffect(() => {
    // jQuery 로드 확인
    const loadSmartEditor = () => {
      if (!window.nhn || !window.nhn.husky) {
        console.error('스마트에디터2 스크립트가 로드되지 않았습니다.');
        return;
      }

      const oEditors: any[] = [];

      // window 객체에 oEditors 노출
      (window as any).oEditors = oEditors;

      window.nhn.husky.EZCreator.createInIFrame({
        oAppRef: oEditors,
        elPlaceHolder: id,
        sSkinURI: '/smarteditor2-2.8.2.3/SmartEditor2Skin.html',
        fCreator: 'createSEditor2',
        htParams: {
          bUseToolbar: true,
          bUseVerticalResizer: true,
          bUseModeChanger: true,
          aAdditionalFontList : [['NanumSquare','나눔스퀘어']],
        },
        fOnAppLoad: function() {
          console.log('스마트에디터2 로드 완료');
          console.log('✅ oEditors:', oEditors);
          editorRef.current = oEditors[0];

          // window에 업데이트
          (window as any).oEditors = oEditors;

          // 기본값 설정 (SET_IR 사용 - 교체 방식)
          if (defaultValue) {
            oEditors[0].exec('SET_IR', [defaultValue]);
          }
        },
      });
    };

    // 스크립트 로드
    const loadScripts = () => {
      // jQuery 확인
      if (!(window as any).jQuery) {
        const jqueryScript = document.createElement('script');
        jqueryScript.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js';
        jqueryScript.onload = () => {
          loadSmartEditorScript();
        };
        document.head.appendChild(jqueryScript);
      } else {
        loadSmartEditorScript();
      }
    };

    const loadSmartEditorScript = () => {
      if (!window.nhn) {
        const seScript = document.createElement('script');
        seScript.src = '/smarteditor2-2.8.2.3/js/HuskyEZCreator.js';
        seScript.charset = 'utf-8';
        seScript.onload = () => {
          loadSmartEditor();
        };
        document.head.appendChild(seScript);
      } else {
        loadSmartEditor();
      }
    };

    loadScripts();

    // 클린업
    return () => {
      if (editorRef.current) {
        try {
          editorRef.current.exec('DESTROY');
        } catch (e) {
          console.log('에디터 정리 중 오류:', e);
        }
      }
    };
  }, [id, defaultValue]);

  // 내용 추출 함수 (부모 컴포넌트에서 사용)
  const getContent = (): string => {
    if (editorRef.current) {
      editorRef.current.exec('UPDATE_CONTENTS_FIELD', []);
    }
    return textareaRef.current?.value || '';
  };

  // 부모 컴포넌트에서 접근할 수 있도록 ref 노출
  useEffect(() => {
    (window as any)[`getContent_${id}`] = getContent;
    return () => {
      delete (window as any)[`getContent_${id}`];
    };
  }, [id]);

  return (
    <div style={{ width: '100%' }}>
      <textarea
        ref={textareaRef}
        id={id}
        name={id}
        style={{ width: '100%', height }}
      />
    </div>
  );
};

export default SmartEditor;
